import * as React from 'react';
import { IgcTabComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A tab element slotted into an `igc-tabs` container.
 * @slot  - Renders the tab's content.
 * @slot label - Renders the tab header's label.
 * @slot prefix - Renders the tab header's prefix.
 * @slot suffix - Renders the tab header's suffix.
 * @csspart tab-header - The header of a single tab.
 * @csspart prefix - Tab header's label prefix.
 * @csspart content - Tab header's label slot container.
 * @csspart suffix - Tab header's label suffix.
 * @csspart tab-body - Holds the body content of a single tab, only the body of the selected tab is visible.
 * @class
 */
export const IgrTab = /* @__PURE__ */ createComponent({
  tagName: 'igc-tab',
  displayName: 'IgrTab',
  elementClass: Component,
  react: React,
});

export type IgrTab = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTabModule = Component;
